import { useMemo, useEffect, useState } from "react";
import { usePlayback } from "hooks/usePlayback";
import { PlotKey } from "utils/packet.worker";
import { packetThreadPoolApi } from "utils/packet-workers";
import { throttle } from "utils/common";
import { TelemValue } from "cstore/telem";

const REFRESH_MS = 25;

export const useSingleTelemetryValue = ( telemetryKey: PlotKey, refreshMs?: number ): TelemValue | undefined => {
    // The following was lifted from Gauge.tsx
    const { timeWindow } = usePlayback();
    const [ latestValue, _setLatestValue ] = useState<TelemValue | undefined>();

    const fetchLatestValue = useMemo( () => throttle( async ( latestTimeMs: number ) => {
        const value = await packetThreadPoolApi.getLatestTelemValueNotAfter( telemetryKey, latestTimeMs );

        _setLatestValue( value ?? undefined );
    }, refreshMs ?? REFRESH_MS ), [ _setLatestValue, telemetryKey, refreshMs ] );

    useEffect( () => {
        const latestTimeMs = timeWindow?.[ 1 ];
        if ( latestTimeMs === undefined ) {
            _setLatestValue( undefined );
            return;
        }

        fetchLatestValue( latestTimeMs );
    }, [ timeWindow, fetchLatestValue ] );
    return latestValue;
};
